import { render, staticRenderFns } from "./TimelineData.vue?vue&type=template&id=08309ac1&"
import script from "./TimelineData.vue?vue&type=script&lang=ts&"
export * from "./TimelineData.vue?vue&type=script&lang=ts&"
import style0 from "./TimelineData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports